import React from 'react'
import PushMenu from './PushMenu'
import logo from 'assets/svg/logo-bg.svg'
import styles from './Header.module.css'

export default function Header(props) {
  return (
    <header className="relative z-50">
      <PushMenu className="lg:hidden">
        <a href="/food-truck-catering/" className="btn btn-blue px-4 py-2 inline-block mb-6">
          Book a Food Truck
        </a>
        <div className={[styles.pushMenuLinks, 'text-white font-light']}>
          <div className="text-xl mb-6">
            <a href="/food-trucks/">Find Food Trucks</a>
            <a href="/food-truck-catering/">Catering</a>
            <a href="/experiential-marketing-agency/">Agency</a>
            <a href="/marketplace/">Marketplace</a>
          </div>
          <div>
            <a href="/pages/about/">About</a>
            <a href="/blog/">Blog</a>
            <a href="/pages/terms_and_conditions/">Terms of Service</a>
            <a href="/pages/privacy_policy/">Privacy Policy</a>
            <a href="#">Contact Us</a>
          </div>
        </div>
      </PushMenu>
      <div className="hidden lg:block border-b border-gray-300">
        <ul className={[styles.masthead, 'container flex']}>
          <li>
            <a href="/food-trucks/">Find Trucks</a>
            <div className={[styles.subnav, styles.subnavEnabled]}>
              <ul className={[styles.cityList, 'container']}>
                <li><a href="/food-trucks/ann-arbor-mi/">Ann Arbor</a></li>
                <li><a href="/food-trucks/atlanta-ga/">Atlanta</a></li>
                <li><a href="/food-trucks/austin-tx/">Austin</a></li>
                <li><a href="/food-trucks/baltimore-md/">Baltimore</a></li>
                <li><a href="/food-trucks/boston-ma/">Boston</a></li>
                <li><a href="/food-trucks/charlotte-nc/">Charlotte</a></li>
                <li><a href="/food-trucks/chicago-il/">Chicago</a></li>
                <li><a href="/food-trucks/cincinnati-oh/">Cincinnati</a></li>
                <li><a href="/food-trucks/cleveland-oh/">Cleveland</a></li>
                <li><a href="/food-trucks/columbus-oh/">Columbus</a></li>
                <li><a href="/food-trucks/dallas-tx/">Dallas</a></li>
                <li><a href="/food-trucks/denver-co/">Denver</a></li>
                <li><a href="/food-trucks/detroit-mi/">Detroit</a></li>
                <li><a href="/food-trucks/hartford-ct/">Hartford</a></li>
                <li><a href="/food-trucks/honolulu-hi/">Honolulu</a></li>
                <li><a href="/food-trucks/houston-tx/">Houston</a></li>
                <li><a href="/food-trucks/indianapolis-in/">Indianapolis</a></li>
                <li><a href="/food-trucks/jacksonville-fl/">Jacksonville</a></li>
                <li><a href="/food-trucks/jersey-city-nj/">Jersey City</a></li>
                <li><a href="/food-trucks/kansas-city-mo/">Kansas City</a></li>
                <li><a href="/food-trucks/las-vegas-nv/">Las Vegas</a></li>
                <li><a href="/food-trucks/london-united-kingdom/">London</a></li>
                <li><a href="/food-trucks/los-angeles-ca/">Los Angeles</a></li>
                <li><a href="/food-trucks/miami-fl/">Miami</a></li>
                <li><a href="/food-trucks/milwaukee-wi/">Milwaukee</a></li>
                <li><a href="/food-trucks/minneapolis-mn/">Minneapolis</a></li>
                <li><a href="/food-trucks/nashville-tn/">Nashville</a></li>
                <li><a href="/food-trucks/new-orleans-la/">New Orleans</a></li>
                <li><a href="/food-trucks/new-york-ny/">New York</a></li>
                <li><a href="/food-trucks/oklahoma-city-ok/">Oklahoma City</a></li>
                <li><a href="/food-trucks/omaha-ne/">Omaha</a></li>
                <li><a href="/food-trucks/orange-county-ca/">Orange County</a></li>
                <li><a href="/food-trucks/orlando-fl/">Orlando</a></li>
                <li><a href="/food-trucks/philadelphia-pa/">Philadelphia</a></li>
                <li><a href="/food-trucks/phoenix-az/">Phoenix</a></li>
                <li><a href="/food-trucks/pittsburgh-pa/">Pittsburgh</a></li>
                <li><a href="/food-trucks/portland-or/">Portland</a></li>
                <li><a href="/food-trucks/providence-ri/">Providence</a></li>
                <li><a href="/food-trucks/raleigh-durham-nc/">Raleigh-Durham</a></li>
                <li><a href="/food-trucks/sacramento-ca/">Sacramento</a></li>
                <li><a href="/food-trucks/salt-lake-city-ut/">Salt Lake City</a></li>
                <li><a href="/food-trucks/san-antonio-tx/">San Antonio</a></li>
                <li><a href="/food-trucks/san-diego-ca/">San Diego</a></li>
                <li><a href="/food-trucks/san-francisco-ca/">San Francisco</a></li>
                <li><a href="/food-trucks/san-jose-ca/">San Jose</a></li>
                <li><a href="/food-trucks/seattle-wa/">Seattle</a></li>
                <li><a href="/food-trucks/st-louis-mo/">St. Louis</a></li>
                <li><a href="/food-trucks/tampa-fl/">Tampa</a></li>
                <li><a href="/food-trucks/toronto-on-canada/">Toronto</a></li>
                <li><a href="/food-trucks/vancouver-bc-canada/">Vancouver</a></li>
                <li><a href="/food-trucks/washington-dc/">Washington DC</a></li>
                <li><a href="/food-trucks/">All Cities</a></li>
              </ul>
            </div>
          </li>
          <li>
            <a href="/food-truck-catering/">Catering</a>
            <div className={[styles.subnav, props.occasionMenu && styles.subnavEnabled]}>
              <div className={[styles.occasionList, 'container grid grid-cols-4 gap-6']}>
                <a href="/food-truck-catering/corporate-catering/">
                  <h3>Workplace Catering</h3>
                  <p>Catered Food Truck Lunch Programs, In-Office Meal Programs, Business Park Lunches, Employee Appreciation, Client Appreciation, Holiday Parties, Milestone Celebrations, Retail Events</p>
                </a>
                <a href="/food-truck-catering/food-truck-wedding/">
                  <h3>Wedding Catering</h3>
                  <p>Wedding Receptions, Rehearsal Dinners, Late Night Snacks, Day-After Brunches</p>
                </a>
                <a href="/food-truck-catering/campus-catering/">
                  <h3>Food Trucks on Campus</h3>
                  <p>Student Organizations, On/Off-Campus Events, Graduation, Prom, School Dances, School Fundraisers, Recruitment Events, Alumni Events</p>
                </a>
                <a href="/food-truck-catering/large-event-food-concessions/">
                  <h3>Large-Scale Events and Multi-City Event Series</h3>
                  <p>Sporting Events, Music Festivals, Arena Concerts, National Event Series, Marathons and Fun Runs</p>
                </a>
                <a href="/food-truck-catering/film-production-catering/">
                  <h3>Production Catering</h3>
                  <p>Movie Set Catering, TV and Film Catering, 24 Hour Production Catering, On Location Catering, Photo Shoots</p>
                </a>
                <a href="/food-truck-catering/local-community-concessions/">
                  <h3>Community Events</h3>
                  <p>Street Fairs, Neighborhood Block Parties, Flea Markets, Little League Games, Car Shows, Real Estate Open Houses, Religious Congregations and Ministries, High School Football Games, Concerts in the Park</p>
                </a>
                <a href="/food-truck-catering/conference-and-event-catering/">
                  <h3>Professional Events</h3>
                  <p>Conferences, Conventions, Expos</p>
                </a>
                <a href="/food-truck-catering/party-catering/">
                  <h3>Private Parties</h3>
                  <p>Birthday, Holiday, Graduation, Anniversary, Bar-Mitzvah, Baby Shower, House Warming</p>
                </a>
              </div>
            </div>
          </li>
          <li className="relative">
            <a href="/" className={styles.logo}>
              <img src={logo} title="Roaming Hunger" alt="Roaming Hunger" />
            </a>
          </li>
          <li><a href="/experiential-marketing-agency/">Agency</a></li>
          <li className="relative">
            <a href="/marketplace/">Marketplace</a>
            <ul className={[styles.subnav, styles.subnavEnabled, 'px-5 text-center']}>
							<li><a href="/marketplace/buy-a-food-truck/">Buy a Food Truck</a></li>
							<li><a href="/marketplace/build-a-food-truck/">Custom Built Food Trucks</a></li>
							<li><a href="/marketplace/sell-a-food-truck/">Sell a Food Truck</a></li>
							<li><a href="/marketplace/lease-a-food-truck/">Lease a Food Truck</a></li>
						</ul>
          </li>
        </ul>
      </div>
    </header>
  )
}
